<script>
import '@splidejs/vue-splide/css/skyblue';

export default {
  components: {},
};
</script>

<template>
  <RouterView />
</template>

<!-- This should generally be the only global CSS in the app. -->
<style>
@import '~normalize.css/normalize.css';
@import '~primevue/resources/themes/saga-blue/theme.css';
@import '~primevue/resources/primevue.min.css';
@import '~primeicons/primeicons.css';
@import '~vue-loaders/dist/vue-loaders.css';
</style>
